<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer004" role="doc-toc">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/Buried#_idTextAnchor001">Buried</a></p>
<p class="TOCitem"><span href="#/Untraceable#_idTextAnchor021" title="Link target outside of Sample">Untraceable</span></p>
<p class="TOCitem">Excerpt from <span href="#/Excerpt#_idTextAnchor044" title="Link target outside of Sample">Treacherous Mountain Investigation</span> by Stephanie M. Gammon</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?2579ad19